import React, { PureComponent } from 'react'
import axios from 'axios'
import ImageUploader from 'react-images-upload';
import Swal from "sweetalert2/dist/sweetalert2";

import Partner from './Partner'
import PartnerName from './PartnerName'
import MenuList from '../Menu'
import { menu, swalText } from "../../../Constants";
import './partners.scss'
import Helpers from "../../../libs/helpers";

export default class Home extends PureComponent {
    constructor(props){
        super(props);
        this.state = {
            partners: [],
            initialized: false,
            picture: [],
        };
    }
    componentDidMount() {
        axios.post('/api/check').then(result => {
            if (result.data.message !== 'you Were authorized') {
                this.props.history.push('/admin');
            }
            axios.post('/api/partners/getAll').then(({ data }) => {
                let { result: partners } = data;
                this.setState({
                    partners,
                    initialized: true,
                });
                document.title = menu[4].text;
            })
        }).catch(res => {
            if (res) {
                this.props.history.push('/admin');
            }
        })
    }

    render() {
        if (!this.state.initialized) return null;
        let module = this.state.temporaryImage ? <img src={'/images/partners/' + this.state.temporaryImage} /> : '';
        const title = 'Այս տողը պարտադիր պետք է սկսվի http:// կամ https:// - ով';

        return (
            <div id='partnersPage'>
                <div id={'mySecondModule'}>
                    <div id="header">
                        <div/>
                        <div>Փոփել նկարը</div>
                        <div className={'closeModule'} onClick={this.closeModule}>X</div>
                    </div>
                    <div id={'main'}>
                        { module }
                    </div>
                    <div id={'footer'}>
                        {<ImageUploader
                            buttonText='Ընտրեք Նկար'
                            onChange={this.changePartnerImage}
                            label='Առավելագույն չափսը 5mb, թույլատրվում է jpg|gif|png'
                            imgExtension={['.jpg', '.gif', '.png']}
                            maxFileSize={5242880}
                            singleImage={true}
                        />}
                    </div>
                </div>
                <MenuList history={ this.props.history }/>
                <div id='right'>
                    <header><h1>{menu[4].text}</h1></header>
                    <div id='addPartner'>
                        <h3><em>Ավելացնել գործընկեր</em></h3>
                        <form onSubmit={this.addPartner}>
                            <div className={'form'}>
                                <div>
                                    <label htmlFor="url">Գործընկերոջ կայքի հասցեն</label>
                                    <input type="url" id='url' placeholder={'Մուտքագրեք կայքի հասցեն'} required title={title} />
                                </div>
                                {['Partner name', 'Имя партнера', 'Գործընկերոջ անունը'].map( (name, index) =>
                                    <PartnerName name={name} key={index} />
                                )}
                                <div>
                                    <ImageUploader
                                        withIcon
                                        singleImage
                                        maxFileSize={5242880}
                                        onChange={this.onDrop}
                                        buttonText='Ընտրեք Նկար'
                                        imgExtension={['.jpg', '.gif', '.png']}
                                        label='Առավելագույն չափսը 5mb, թույլատրվում է jpg|gif|png'
                                    />
                                </div>
                                <div><button>Ավելացնել</button></div>
                            </div>
                        </form>
                    </div>
                    <div id={'showPartners'}>
                        <div><h3><em>Մեր գործընկերները</em></h3></div>
                        <div id='partnersTags'>
                            {this.state.partners.map(el =>
                                <Partner
                                    src={ el.src }
                                    key={ el.id }
                                    id={ el.id }
                                    url={ el.link }
                                    data={ el.data }
                                    changePartner={this.changePartner}
                                    printImage={this.printImage}
                                    closeModule={this.closeModule}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    onDrop = picture => {
        if(picture.length > 1) picture.shift();
        this.setState({ picture });
    };

    changePartner = partners => {
        this.setState({ partners })
    };

    changePartnerImage = picture => {
        let formData = new FormData(),
            module = document.querySelector('#mySecondModule'),
            id = module.dataset.id,
            src = module.querySelector('img').src.split('/').reverse()[0];
        formData.append('image', picture[0]);
        formData.append('id', id);
        formData.append('src', src);
        axios.put('/api/partners/changeImage', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(({ data }) => {
            if(data.message === 'image changed'){
                document.removeEventListener('click', this.closeModule);
                let myModule = document.querySelector('#mySecondModule');
                myModule.classList.remove('openModule');
                myModule.dataset.id = '';
                Swal.fire({
                    type: 'success',
                    title: 'Նկարը փոխվեց'
                });
                this.changePartner(data.result);
                picture = [];
            }
        })
    };

    printImage = image => {
        this.setState({ temporaryImage : image })
    };

    closeModule = e => {
        if (!e.target.closest('#mySecondModule') || e.target.classList.contains('closeModule')) {
            let myModule = document.querySelector('#mySecondModule');
            myModule.classList.remove('openModule');
            myModule.dataset.id = '';
            document.removeEventListener('click', this.closeModule);
            this.setState({ temporaryImage: false })
        }
    };

    addPartner = e => {
        e.preventDefault();
        let url = document.querySelector('#url').value.trim();
        let names = document.querySelectorAll('.names>input');
        let info = [...names].map(el => el.value.trim());
        if(!Helpers.checkUrl(url)) {
            Swal.fire({
                title: "Տողը ճանապարհ չէ(url)",
                text: 'Տողը պետք է սկսի http:// կամ https:// - ով',
                type: 'error'
            });
            return;
        }
        let errors = Helpers.checkErrors(info);
        if(errors.length){
            Swal.fire({
                type: 'error',
                title: 'Կիսատ ինֆորմացիա',
                text: 'Լրացրեք բոլոր դաշտերը'
            });
            let tags = document.querySelectorAll('.names > input');
            return tags.forEach((el, index) => {
                errors.includes(index) ? el.classList.add('error') : el.classList.remove('error');
            });
        }
        let [enName, ruName, armName] = info;
        const picture = this.state.picture;
        if(!picture.length){
            Swal.fire({
                title: "Նկար ընտրված չէ(url)",
                type: 'error'
            });
            return;
        }

        let formData = new FormData();
        formData.append('image', picture[0]);
        formData.append('url', url);
        formData.append('enName', enName);
        formData.append('ruName', ruName);
        formData.append('armName', armName);
        axios.put('/api/partners/add', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(({ data }) => {
            if(data.message !== 'Photo added') {
                Swal.fire({
                    title: "Ավելացնել չստացվեց",
                    text: 'Խնդրում ենք դիտել url - ի ճծտությանը, և ֆայլի նկար լինելը',
                    type: 'error'
                });
                return;
            }
            const {id, src} = data;
            let newPartner = {
                id,
                src,
                link: url,
            };
            this.setState(({ partners }) => ({
                partners: [...partners, newPartner],
                picture: []
            }), () => {
                document.querySelector('#url').value = '';
                Swal.fire({
                    title: swalText.titleSuccess,
                    confirmButtonText: swalText.ok,
                    type: 'success'
                })
            });
        })
    }
}